<template>
  <!-- Content Left Rail -->
  <div class="settings-center-rail">
    <personal-settings
      v-if="settingsNavSelected == 'personal'"
      ref="personal-pane"
    ></personal-settings>
    <account-settings
      v-if="settingsNavSelected == 'account'"
      ref="account-pane"
    ></account-settings>
    <user-management
      v-if="settingsNavSelected == 'users'"
      ref="user-management-pane"
    ></user-management>
    <customer-settings
      v-if="settingsNavSelected == 'customers'"
      ref="customer-pane"
    ></customer-settings>
    <calendar-settings
      v-if="settingsNavSelected == 'calendar'"
      ref="calendar-pane"
    ></calendar-settings>
    <list-settings
      v-if="settingsNavSelected == 'list'"
      ref="lists-pane"
    ></list-settings>
    <telecom-settings
      v-if="
        ['telecom-fwd', 'telecom-trck', 'telecom-flow'].includes(
          settingsNavSelected
        )
      "
      ref="telecom-pane"
    ></telecom-settings>
    <!-- <settings-tester
      v-if="settingsNavSelected == 'tester'"
      ref="settings-tester"
    ></settings-tester> -->
  </div>
</template>

<script>
const PersonalSettings = () =>
  import(
    /* webpackChunkName: "components-settings-PersonalSettings" */ `./PersonalSettings.vue`
  );
const AccountSettings = () =>
  import(
    /* webpackChunkName: "components-settings-AccountSettings" */ `./AccountSettings.vue`
  );
const UserManagement = () =>
  import(
    /* webpackChunkName: "components-settings-UserManagement" */ `./UserManagement.vue`
  );
const CustomerSettings = () =>
  import(
    /* webpackChunkName: "components-settings-CustomerSettings" */ `./CustomerSettings.vue`
  );
const CalendarSettings = () =>
  import(
    /* webpackChunkName: "components-settings-CalendarSettings" */ `./CalendarSettings.vue`
  );
const TelecomSettings = () =>
  import(
    /* webpackChunkName: "components-settings-TelecomSettings" */ `./TelecomSettings.vue`
  );
const ListSettings = () =>
  import(
    /* webpackChunkName: "components-settings-ListSettings" */ `./ListSettings.vue`
  );
// const SettingsTester = () =>
//   import(
//     /* webpackChunkName: "components-settings-SettingsTester" */ `./SettingsTester.vue`
//   );

export default {
  name: "SettingsCenterRail",
  components: {
    PersonalSettings,
    AccountSettings,
    UserManagement,
    CustomerSettings,
    CalendarSettings,
    TelecomSettings,
    ListSettings
  },
  props: {
    msg: String
  },
  data: function() {
    return {
      toggleFilter: 1
    };
  },
  created() {},
  watch: {},
  computed: {
    settingsNavSelected() {
      return this.$parent.$parent.$parent.settingsNavSelected;
    }
  },
  methods: {
    navigateTo(settingType) {
      settingType;
    }
  }
};
</script>

<style scoped lang="stylus">
div.settings-left-nav, div.settings-left-nav div {
  background-color: rgb(241, 241, 241);
  width: 100%;
}
.settings-left-nav div.v-list {
  padding: 0;
}
.v-list-item__title {
  padding: 1.5rem 2rem 0.5rem;
  font-size: 1rem;
  font-weight: 500;
  text-transform: uppercase;
}
.subtitle-1 {
  font-size: 1rem;
  font-weight: 400;
}
.v-list-item {
  padding: .5rem 2rem;
}
.settings-center-rail {
  width: 100%;
  padding: 0;
}
</style>
